export enum MessengerType {
	Signal = 'signal',
	Skype = 'skype',
	Telegram = 'telegram',
	Whatsapp = 'whatsapp',
}
